module.exports = __webpack_public_path__ + "img/avatar.915ba2cb.jpg";